import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/dental/Layout";
import Home from "./pages/Home";
import OurPractice from "./pages/OurPractice";
import MeetDoctor from "./pages/MeetDoctor";
import {FullMouthRehabilitationPage} from "./pages/FullMouthRehabilitationPage";
import DentalServicesPage from "./pages/DentalServicesPage";
import SpaServicesPage from "./pages/SpaServicesPage";
import ServiceDetail from "./pages/ServiceDetail";
import { ServiceDetailPage } from "./pages/ServiceDetail";
import SmileGallery from "./pages/SmileGallery";
import DigitalSmile from "./pages/DigitalSmile";
import ForPatients from "./pages/ForPatients";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-practice" element={<OurPractice />} />
          <Route path="/meet-the-doctor" element={<MeetDoctor />} />
          <Route path="/dental-services" element={<DentalServicesPage />} />
          <Route path="/services" element={<DentalServicesPage />} />
            <Route path="/services/full-mouth-rehabilitation" element={<FullMouthRehabilitationPage />} />

          <Route path="/dental-services/:slug" element={<ServiceDetail kind="dental" />} />
          <Route path="/spa-services" element={<SpaServicesPage />} />
          <Route path="/services/aesthetic-dentistry" element={<SpaServicesPage />} />
         
          <Route path="/spa-services/:slug" element={<ServiceDetail kind="spa" />} />
          <Route path="/services/:slug" element={<ServiceDetailPage />} />
          <Route path="/services/:slug/:subslug" element={<ServiceDetailPage />} />
          <Route path="/smile-gallery" element={<SmileGallery />} />
          <Route path="/digital-smile-design" element={<DigitalSmile />} />
          <Route path="/for-patients" element={<ForPatients />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
